import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Table,
  PageHeader,
  Button,
  Divider,
  Form,
  Input,
  message,
  Upload,
  Select,
  Switch,
  Checkbox,
  Modal,
  Segmented,
  Radio,
  DatePicker,
} from "antd";

import {
  FlexRowContainer,
  FlexRowEndContainer,
  FlexRowQuarterContainer,
  FlexRowReverseContainer,
} from "../Common/Container.styles";
import {
  dateToCompactString,
  dateToString,
  numberWithCommas,
} from "../../util/common";


import * as userAPI from "../../api/user";

import {
  CloseOutlined,
  CheckOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import {createCertificateType} from "../../api/user";

function BasicSettingPage({ isEdit }) {
  const forms = [
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
    Form.useForm()[0],
  ];

  const [ipForm] = Form.useForm();

  const navigate = useNavigate();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [setting, setAdmin] = useState(null);

  const [image, setImage] = useState(null);

  const fetchAdmin = () => {
    userAPI
      .getCertificateTypes2({ page: 1, size: 100 })
      .then((res) => {
        if (res.data.linusCode === 1) {
          setAdmin(res.data.data);
          setLoading(false);
        } else {
          alert(res.data.data.msg);
        }
      })
      .catch((error) => {
        if (error.response.data.detail) {
          message.error(error.response.data.detail);
        } else if (error.response.status < 500) {
          for (let key of Object.keys(error.response.data)) {
            message.error(`${key}: ${error.response.data[key]}`);
          }
        } else {
          message.error("오류가 발생했습니다.");
        }
      });
  };

  const columns = [
    {
      title: "번호",
      dataIndex: "id",
    },
    {
      title: "자격명",
      width: "30%",
      dataIndex: "name",
      render: (val) => {
        return val;
      },
    },
    {
      title: "연결된 검사 도구",
      dataIndex: "products",
      width: "20%",
      render: (products) => {
        if (!products || products.length === 0) return "-";
        return (
          <>
            {products.map((p, idx) => (
              <div key={idx}>[{p.product_group}] {p.product_name}</div>
            ))}
          </>
        );
      }
    },
    {
      title: "할인율",
      dataIndex: "discount_rate",
      width: "10%",
        render: (val) => {
          return `${val || 0}%`;
      },
    },
    {
      title: "사용여부",
      dataIndex: "use_yn",
      width: "8%",
      render: (val) => (val === "Y" ? "예" : "아니오"),
    },
    {
      title: "삭제여부",
      dataIndex: "del_yn",
      width: "8%",
      render: (val) => (val === "Y" ? "예" : "아니오"),
    },
    {
      title: "작성자",
      dataIndex: "",
      width: "8%",
      render: (val) => {
        return "관리자";
      },
    },
    {
      title: "등록일",
      dataIndex: "createdDate",
      width: "8%",
      render: (val) => {
        return val;
      },
    },
    {
      title: "수정일",
      dataIndex: "updatedDate",
      width: "12%",
      render: (val) => {
        return val;
      },
    },
  ];
  useEffect(() => {
    fetchAdmin();
  }, []);

const onAdd = (e) => {
    e.preventDefault();
    navigate(`/user/certificate-type2/new`)
  };

  return (
    <>
      <div>
        <PageHeader
          className="site-page-header"
          title={`구매 자격 종류 관리`}
        />
        <Divider />
        {loading && <></>}
      </div>
      {!loading && (
        <>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
            <Button type="primary" icon={<CheckOutlined />} onClick={onAdd} >
              등록
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Table
                      pagination={false}
                      loading={loading}
                      columns={columns}
                      dataSource={setting}
                      onRow={(record, rowIndex) => {
                        return {
                          //onClick: (event) => {console.log(record)}, // click row
                          onClick: (event) => {navigate(`/user/certificate-type2/${record.id}`)}, // click row
                          onDoubleClick: (event) => {}, // double click row
                          onContextMenu: (event) => {}, // right button click row
                          onMouseEnter: (event) => {}, // mouse enter row
                          onMouseLeave: (event) => {}, // mouse leave row
                        };
                      }}
                      style={{ cursor: "pointer" }}
                    />
          
            <Divider/>
            <Form
              form={forms[0]}
              initialValues={{}}
              scrollToFirstError
              style={{ width: "50%" }}
              onFinish={(val) => {
                userAPI
                  .createCertificateType({ ...val })
                  .then((res) => {
                    if (res.data.linusCode === 1) {
                      message.success("성공적으로 반영되었습니다.");
                      setAdmin(setting?.concat([res.data.data]))
                    }
                  });
              }}
            >
              {/* <div style={{ display: "flex" }}>
                <Form.Item
                  fieldKey={'new'}
                  name="name"
                  // label={i.name}
                  style={{
                    width: "500px",
                  }}
                  defaultValue={''}
                >
                  <Input
                    placeholder={`자격증 이름을 입력해주세요.`}
                  />
                </Form.Item>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginLeft: "10px",
                  }}
                >
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      icon={<CheckOutlined />}
                    >
                      추가
                    </Button>
                  </Form.Item>
                </div>
              </div> */}
            </Form>
          </div>
        </>
      )}
    </>
  );
}

export default BasicSettingPage;
